var lists_default = {
  "fontElementMap": "wPCic",
  "orderedlist": "oMHlg",
  "bulletedlist": "ICCsA",
  "listItem": "fU9RR"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
